var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"languageSelection mb-5",attrs:{"filled":"","hide-details":"","value":_vm.previewLocale,"items":_vm.appLocales,"item-text":"name","item-value":"ietfLanguageTag","label":_vm.selectionLabel},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }